import { styled } from '@mui/material';
import { hexToRgba } from '../../utils/color';

export const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  position: 'fixed',
  top: theme.spacing(12),
  left: '50%',
  transform: 'translate(-50%)',
  borderRadius: theme.spacing(1),
  color: theme.palette.common.white,
  backgroundColor: hexToRgba(theme.palette.common.black, 0.5),
  backdropFilter: 'blur(4px)',
  zIndex: 2000,
}));
